import { TEACHERS } from "@/data/content";
import { useReveal } from "@/hooks/useReveal";

export function Teachers() {
  const head = useReveal();
  return (
    <section id="profs" data-testid="teachers-section" className="relative py-20 md:py-28 bg-ink">
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div ref={head.ref} className={head.className}>
          <p className="font-mono2 text-xs uppercase tracking-[0.3em] text-emerald-bright mb-3">L'équipe</p>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight max-w-3xl">
            Nos profs <span className="text-mustard">& mentors</span>
          </h2>
          <p className="mt-5 max-w-2xl text-cream/70 leading-relaxed">
            Une équipe passionnée qui transmet bien plus que des pas : le respect, la
            confiance et l'amour de la culture. Ils sont les grands frères et grandes sœurs de la Factory.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-5 mt-12">
          {TEACHERS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`teacher-${i}`}
              className="relative rounded-2xl bg-ink-2 border border-white/5 p-6 card-hover overflow-hidden"
            >
              <div
                className="absolute -top-10 -right-10 w-32 h-32 rounded-full blur-2xl opacity-25"
                style={{ background: t.color }}
              />
              <div
                className="relative w-16 h-16 rounded-2xl flex items-center justify-center font-display font-black text-xl"
                style={{ background: `${t.color}22`, color: t.color, border: `1px solid ${t.color}55` }}
              >
                {t.initials}
              </div>
              <h3 className="relative mt-4 font-sub font-bold text-xl text-cream">{t.name}</h3>
              <p className="relative mt-1 text-sm text-cream/55">{t.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
